import API from '../../sunwiseAPI';
const ENTITY = 'interactive-monitoring';
const config = { headers: { 'Content-Type': 'application/json' } };

export const create = (data) =>
    API.post(`/api/v1/${ENTITY}/public/`, data, config);
